interface GetTooltipText {
  isNegative?: boolean
  isPositive?: boolean
}

export const getThumbsUpTooltip = ({ isNegative, isPositive }: GetTooltipText) => {
  switch (true) {
    case isPositive:
      return 'Remove Helpful'
    case isNegative:
      return 'Change to helpful'
    default:
      return 'This was helpful'
  }
}

export const getThumbsDownTooltip = ({ isNegative, isPositive }: GetTooltipText) => {
  switch (true) {
    case isPositive:
      return 'Change to unhelpful'
    case isNegative:
      return 'Remove Unhelpful'
    default:
      return 'This wasn’t helpful'
  }
}
